/*
 * @Author: yanghailong
 * @Date: 2025-03-27 11:08:00
 * @Last Modified by:   yanghailong
 * @Last Modified time: 2025-03-27 11:08:00
 */



// HSV 转 RGB
export function hsvToRgb(h, s, v) {
  let r, g, b
  const i = Math.floor(h / 60) % 6
  const f = h / 60 - Math.floor(h / 60)
  const p = v * (1 - s)
  const q = v * (1 - f * s)
  const t = v * (1 - (1 - f) * s)

  // 根据色相计算RGB值
  switch (i) {
    case 0:
      r = v
      g = t
      b = p
      break
    case 1:
      r = q
      g = v
      b = p
      break
    case 2:
      r = p
      g = v
      b = t
      break
    case 3:
      r = p
      g = q
      b = v
      break
    case 4:
      r = t
      g = p
      b = v
      break
    case 5:
      r = v
      g = p
      b = q
      break
  }

  return {
    r: Math.round(r * 255), // 将值缩放到0-255
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  }
}


// RGB 转 Hex
export function rgbaToHex(r, g, b, a) {
  const alpha = Math.round(a * 255) // 将alpha值转换为0-255
  return `#${((1 << 24) + (r << 16) + (g << 8) + b + (alpha << 24)).toString(16).slice(1)}` // 通过位运算生成Hex字符串
}


// Hex 转 HSV
export function hexToHsv(hex) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const delta = max - min
  let h, s, v
  if (delta === 0) {
    h = 0
  } else if (max === r) {
    h = ((g - b) / delta) % 6
  } else if (max === g) {
    h = (b - r) / delta + 2
  } else {
    h = (r - g) / delta + 4
  }
  h = Math.round(h * 60)
  if (h < 0) {
    h += 360
  }
  v = max / 255
  s = delta === 0 ? 0 : delta / (255 - Math.min(r, g, b))
  return { h, s, v }
}

function clamp255(value) {
  return Math.max(0, Math.min(255, Math.round(Number(value))))
}

function clampAlpha(value) {
  const n = Number(value)
  if (Number.isNaN(n)) return 1
  return Math.max(0, Math.min(1, n))
}

/** 解析 css 颜色字符串为 { r, g, b, a } */
export function parseColor(color) {
  if (!color || typeof color !== 'string') {
    return { r: 255, g: 0, b: 0, a: 1 }
  }

  const str = color.trim()

  const rgbaMatch = str.match(
    /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([\d.]+))?\s*\)$/i,
  )
  if (rgbaMatch) {
    return {
      r: clamp255(rgbaMatch[1]),
      g: clamp255(rgbaMatch[2]),
      b: clamp255(rgbaMatch[3]),
      a: rgbaMatch[4] !== undefined ? clampAlpha(rgbaMatch[4]) : 1,
    }
  }

  if (str.startsWith('#')) {
    let hex = str.slice(1)
    if (hex.length === 3) {
      hex = hex.split('').map((c) => c + c).join('')
    }
    if (hex.length === 6 || hex.length === 8) {
      const r = parseInt(hex.slice(0, 2), 16)
      const g = parseInt(hex.slice(2, 4), 16)
      const b = parseInt(hex.slice(4, 6), 16)
      const a = hex.length === 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1
      if (![r, g, b].some(Number.isNaN)) {
        return { r, g, b, a }
      }
    }
  }

  return { r: 255, g: 0, b: 0, a: 1 }
}

/** RGB(0-255) 转 HSV，h: 0-360, s/v: 0-1 */
export function rgbToHsv(r, g, b) {
  r /= 255
  g /= 255
  b /= 255
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const delta = max - min
  let h = 0
  const v = max
  const s = max === 0 ? 0 : delta / max

  if (delta !== 0) {
    if (max === r) {
      h = ((g - b) / delta) % 6
    } else if (max === g) {
      h = (b - r) / delta + 2
    } else {
      h = (r - g) / delta + 4
    }
    h *= 60
    if (h < 0) h += 360
  }

  return { h, s, v }
}

/** 格式化为 css 颜色字符串 */
export function formatRgba(r, g, b, a = 1) {
  if (a >= 1) {
    return `rgb(${r}, ${g}, ${b})`
  }
  const alpha = Math.round(a * 100) / 100
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
